import React from 'react';
import styled from 'styled-components';

import { PublicSessionLoginContinue } from 'src/assets/public-session-login-continue';
import { PublicSessionLoginSuccess } from 'src/assets/public-session-login-success';
import { Title, Subtitle, KIOSK_PRO_MEDIA } from 'src/components/kiosk-pro/kiosk-pro-shared/kiosk-pro-shared.styles';

export function KioskLoginContinue({
  isUserLoggedInSuccessfully,
  userFirstName,
  isInModal = false,
}: {
  isUserLoggedInSuccessfully: boolean;
  userFirstName: string;
  isInModal?: boolean;
}): JSX.Element {
  return (
    <ContentContainer $isInModal={isInModal}>
      {isUserLoggedInSuccessfully ? (
        <>
          <PublicSessionLoginSuccess />
          <ContinueTitle $isInModal={isInModal}>
            <span aria-hidden='true'>👋</span>
            &nbsp; Hi, {userFirstName}!
          </ContinueTitle>
        </>
      ) : (
        <>
          <PublicSessionLoginContinue />
          <TextContainer $isInModal={isInModal}>
            <ContinueTitle $isInModal={isInModal}>Continue on your phone</ContinueTitle>
            <ContinueSubTitle $isInModal={isInModal}>This screen will automatically refresh</ContinueSubTitle>
          </TextContainer>
        </>
      )}
    </ContentContainer>
  );
}

const ContentContainer = styled.div<{ $isInModal?: boolean }>`
  max-width: 1000px;
  width: 100%;
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${({ $isInModal }) => ($isInModal ? '56px' : '72px')};
  text-align: center;

  svg {
    width: 220px;
    height: 220px;
  }

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    gap: ${({ $isInModal }) => ($isInModal ? '40px' : '56px')};
    svg {
      width: ${({ $isInModal }) => ($isInModal ? '156px' : '220px')};
      height: ${({ $isInModal }) => ($isInModal ? '156px' : '220px')};
    }
  }

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    gap: ${({ $isInModal }) => ($isInModal ? '40px' : '56px')};
    svg {
      width: 156px;
      height: 156px;
    }
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    gap: ${({ $isInModal }) => ($isInModal ? '36px' : '48px')};
    svg {
      width: 112px;
      height: 112px;
    }
  }
`;

const ContinueTitle = styled(Title)<{ $isInModal?: boolean }>`
  font-size: ${({ $isInModal }) => ($isInModal ? '56px' : '72px')};
  font-weight: 700;

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth}, ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    font-size: ${({ $isInModal }) => ($isInModal ? '40px' : '56px')};
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    font-size: ${({ $isInModal }) => ($isInModal ? '36px' : '48px')};
  }
`;

const ContinueSubTitle = styled(Subtitle)<{ $isInModal?: boolean }>`
  font-size: ${({ $isInModal }) => ($isInModal ? '24px' : '36px')};
  font-weight: 500;

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth}, ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    font-size: ${({ $isInModal }) => ($isInModal ? '20px' : '28px')};
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    font-size: ${({ $isInModal }) => ($isInModal ? '16px' : '24px')};
  }
`;

const TextContainer = styled.div<{ $isInModal?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    padding: ${({ $isInModal }) => ($isInModal ? '0' : '0 66px')};
  }
`;
